export default __webpack_public_path__ + "static/media/gallery_a-min.3d52dd16.jpg";